"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPOVER_TYPES = void 0;
const POPOVER_TYPES = exports.POPOVER_TYPES = ['success', 'info', 'warning', 'error'];